import React, { useRef, useState } from 'react';
import { X, Plus } from 'react-bootstrap-icons';

export default function FaqAccordion({ faq, colors }) {
  const [activeCard, setActiveCard] = useState(null);
  const [activeData, setActiveData] = useState(null);
  const productRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  const handleCardClick = (index, data) => {
    setActiveCard(index === activeCard ? null : index);
    setActiveData(data);
  };    
    
  return (
    <>
      <div className="relative flex flex-col mt-6 lg:max-w-7xl mx-auto px-0">
        {faq?.map((_, index) => (
          <div 
            key={index} 
            className={`relative transition-all duration-1000 ease-in-out w-full p-1`}
          >
            <div
              style={{
                maxHeight: activeCard === index ? 500 : 100,
                backgroundColor: activeCard === index ? '${colors?.primary}10' : `${colors?.primary}10`
              }}
              className={`relative flex items-center transform px-12 max-sm:px-4 py-8 max-sm:py-4 transition-all duration-500 ease-in-out w-full ${
                activeCard === index ? '' : 'h-[100px]'
              } overflow-hidden`}
            >
              {activeCard !== index && (
                <div className="w-full transition-opacity duration-500 ease-in-out opacity-100 flex items-center gap-5">
                  <h1 
                    className='text-3xl not-italic font-bold leading-[120%] tracking-[0.25px]'
                    style={{ color: colors?.primary }}
                  >
                    {index+1 < 10 ? `0${index+1}` : index+1}
                  </h1>
                  <div className="text-left flex-grow space-y-0">
                    <p className="gap-3 font-[TATAAIARegularPrint] text-lg not-italic font-semibold leading-[normal]"
                       style={{ color: "#282727" }}
                    >
                      {_.title}
                    </p>
                  </div>
                  <Plus 
                    onClick={() => handleCardClick(index, _)} 
                    className="font-semibold cursor-pointer bg-white rounded-full text-[18px] ml-auto" 
                    style={{ color: "#282727" }}
                  />
                </div>
              )}

              {activeCard === index && (
                <div ref={productRef} className="w-full">
                  <div className="flex items-center gap-5 relative">
                    <h1 
                      className='text-3xl not-italic font-bold leading-[120%] tracking-[0.25px] self-start mt-2'
                      style={{ color: colors?.primary }}
                    >
                      {index+1 < 10 ? `0${index+1}` : index+1}
                    </h1>
                    <div className='space-y-2 flex-grow'>
                      <p 
                        className="text-left font-[TATAAIARegularPrint] text-2xl not-italic font-semibold leading-[normal]"
                        style={{ color: "#282727" }}
                      >
                        {_.title}
                      </p>
                      <p 
                        className="font-[HelveticaNeueLTStd] text-left text-gray-500 text-sm not-italic pr-6 font-medium leading-[normal]"
                      >
                        {_.description.split('\n').map((text, i) => (
                          <React.Fragment key={i}>
                            {text}
                            {i < _.description.split('\n').length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                    </div>
                    <X 
                      className="text-[#fff] rounded-full text-lg cursor-pointer absolute top-1/2 -translate-y-1/2 right-0" 
                      style={{ backgroundColor: "#282727" }}
                      onClick={() => setActiveCard(null)} 
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>    
  );
}

